import { useSelector } from 'react-redux';
import * as styles from './styles.css';
import { EBannerType, IBanners } from 'shared/types/guide';
import { selectOfferType } from 'shared/selectors/offerType';
import { EOfferType } from 'shared/types/wantType';
import { BlueBanner } from 'shared/components/BlueBanner';
import { ColoredBanner } from 'shared/components/ColoredBanner';

interface IListItemBannersProps {
  mainBanner: IBanners;
  secondBanner?: IBanners;
}

export const ListItemBanners: React.FC<IListItemBannersProps> = ({ mainBanner, secondBanner }) => {
  const offerType = useSelector(selectOfferType);

  const currentBanner = secondBanner ? (offerType === EOfferType.Apartment ? mainBanner : secondBanner) : mainBanner;

  if (!mainBanner.linkBtn.url) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {currentBanner.type === EBannerType.Blue ? (
        <BlueBanner mainBanner={currentBanner} />
      ) : (
        <ColoredBanner {...currentBanner} />
      )}
    </div>
  );
};
